import { IIconProps } from "../types"

export default function IconUR1(props: IIconProps) {
  const width = props.size || props.width || (93 / 5) * 3
  const height = props.size || props.height || (118 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 93 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.4206 0.545229C49.2097 0.765158 51.6589 1.265 54.498 2.32466C57.3371 3.38432 60.546 4.9938 63.595 7.40303C66.6441 9.81226 69.5132 13.0312 72.9021 20.3889C76.291 27.7565 80.1797 39.2628 83.0188 48.3099C85.8479 57.367 87.6273 63.9749 88.9769 70.2729C90.3365 76.5808 91.2662 82.5889 91.816 87.7073C92.3658 92.8256 92.5358 97.0543 92.1159 100.693C91.686 104.332 90.6664 107.381 89.5767 109.58C88.4671 111.78 87.2875 113.129 85.0482 114.149C82.7989 115.158 79.4999 115.838 73.7918 116.308C68.0736 116.768 59.9562 117.028 50.6492 116.728C41.3422 116.428 30.8455 115.588 23.6079 114.659C16.3802 113.719 12.4015 112.709 9.57237 111.23C6.73328 109.75 5.04382 107.801 3.68426 105.092C2.33469 102.383 1.31502 98.9137 0.805179 94.6451C0.305339 90.3664 0.305339 85.2881 0.975124 78.8201C1.65491 72.3422 3.00447 64.4747 5.04382 55.4676C7.07317 46.4505 9.7823 36.3038 12.0216 29.236C14.2609 22.1683 16.0403 18.1896 18.2396 14.7207C20.4389 11.2518 23.068 8.29274 26.327 6.00348C29.576 3.72421 33.4747 2.11473 36.9836 1.265C40.4925 0.425267 43.6215 0.335296 46.4206 0.545229Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
